import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';

@Component({
  selector: 'app-catalogs-preparations-card',
  templateUrl: './catalogs-preparations-card.component.html',
  styleUrls: ['./catalogs-preparations-card.component.scss']
})
export class CatalogsPreparationsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enabledCount: any;
  disabledCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('preparations-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('preparations-counts-spinner');
      this.showCounter = true;
      this.enabledCount = this.data.availablePreparations;
      this.disabledCount = this.data.unavailablePreparations;
    } else if ('-' === this.data) {
      this.enabledCount = '-';
      this.disabledCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('preparations-counts-spinner');
    }
  }

}
